// extracted by mini-css-extract-plugin
export default {"login":"LoginPage_login__WCbDN","container":"LoginPage_container__FpSna","wrapper":"LoginPage_wrapper__30++x"};